import $ from 'jquery'

let googleReady = false;

(function() {
    var t = setInterval(function(){
        if(typeof window.google != "undefined"){
            clearInterval(t);
            googleReady = true;
        }
    },100);
})();

function GoogleMap(el) {
    this.el = el.get(0);
    this.data = el.data('google-map');
    this.map = null;
    this.geo = null;
    this.mapImage = null;
    this.marker = null;
    this.bounds = null;
    this.mapOptions = {
        zoom: this.data.zoom || 12,
        scrollwheel: true,
        draggable: true,
        center: false,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        zoomControl: true,
        mapTypeControl:false,
        streetViewControl: false,
        panControl:false,
        styles: [
            {
              "stylers": [
                { "saturation": -100 }
              ]
            }
          ]
    };

    if(!googleReady) {
        var t = setInterval( () => {
            if(!googleReady) return;
            clearInterval(t);
            this.init();
        },100 );
    } else {
        this.init();
    }
    el.data('gm',this);
}

GoogleMap.prototype.init = function() {
    $(window).on('resize',this.onResize);

    this.bounds = new google.maps.LatLngBounds();

    if(this.data.marker) {
        var marker = this.data.marker;
        var sWidth = (marker.scale) ? Math.round( marker.width * marker.scale ) : marker.width;
        var sHeight = (marker.scale) ? Math.round( marker.height * marker.scale ) : marker.height;
        this.mapImage = {
            url: marker.url,
            size: new google.maps.Size(marker.width, marker.height),
            origin: new google.maps.Point(0,0),
            anchor: new google.maps.Point(Math.round(sWidth / 2),sHeight),
            scaledSize: new google.maps.Size(sWidth,sHeight),
        };
    }

    if(this.data.hasOwnProperty('lat') && this.data.hasOwnProperty('lng')) {
        var lat = parseFloat(this.data.lat);
        var lng = parseFloat(this.data.lng);
        this.mapOptions.center = new google.maps.LatLng(lat,lng);
        this.show();
    } else if(this.data.address) {
        this.geocode(this.data.address,(loc) => {
            this.mapOptions.center = loc;
            this.show();
        } );
    }


}

GoogleMap.prototype.geocode = function(address,callback) {
    if(!this.geo) this.geo = new google.maps.Geocoder();
    this.geo.geocode({'address': this.data.address}, (results,status) => {
        var loc = false;
        if (status == google.maps.GeocoderStatus.OK) {
            loc = results[0].geometry.location;
        }
        callback( loc );
     });
}

GoogleMap.prototype.show = function() {

    if(!this.map) {
        this.map = new google.maps.Map(this.el,this.mapOptions);
        if(this.data.locations) {
            this.data.locations.forEach( loc => {
                var marker = new google.maps.Marker({
                    position: new google.maps.LatLng( loc.lat, loc.lng ),
                    map: this.map,
                    icon: this.mapImage,
                });
                this.bounds.extend( marker.position );
            } );
            this.map.fitBounds( this.bounds );
        } else {
            this.marker = new google.maps.Marker({
                position: this.mapOptions.center,
                map: this.map,
                icon : this.mapImage
            });
            this.bounds.extend( this.marker.position );
            if(this.mapImage) {
                google.maps.event.addListenerOnce(this.map,'tilesloaded',() => {
                    this.map.setCenter( this.getMapCenter() );
                });
            }
        }

    } else {
        this.map.setZoom( this.mapOptions.zoom );
        if(this.marker)this.marker.setPosition(this.mapOptions.center);
        this.map.setCenter(this.getMapCenter());
    }
}

GoogleMap.prototype.getMapCenter = function() {
    if(!this.mapImage) {
        return this.mapOptions.center;
    }
    var offsetx = 0;
    var offsety = this.mapImage.scaledSize.height * -0.5;
    var zoom = this.map.getZoom();
    var point1 = this.map.getProjection().fromLatLngToPoint( this.mapOptions.center );
	var point2 = new google.maps.Point(
		( (typeof(offsetx) == 'number' ? offsetx : 0) / Math.pow(2, zoom) ) || 0,
		( (typeof(offsety) == 'number' ? offsety : 0) / Math.pow(2, zoom) ) || 0
	);
    return this.map.getProjection().fromPointToLatLng(new google.maps.Point(
		point1.x - point2.x,
		point1.y + point2.y
	));
}

GoogleMap.prototype.setLocation = function(loc) {
    if(typeof loc == "undefined") {
        if(this.map.fitBounds( this.bounds ));
    } else if(typeof loc == "string") {
        this.geocode(loc,(loc) => {
            this.mapOptions.center = loc;
            this.show();
        });
    } else if(typeof loc == "object" && loc.hasOwnProperty('lat') && loc.hasOwnProperty('lng')) {
        this.mapOptions.center = new google.maps.LatLng(parseFloat(loc.lat),parseFloat(loc.lng));
        this.show();
    }
}

GoogleMap.prototype.onResize = function() {
    if(!this.map)return;
    var center = this.map.getCenter();
    google.maps.event.trigger(this.map, "resize");
    this.map.setCenter(center);
}

$(function() {
    $('[data-google-map]').each(function() {
        var gm = new GoogleMap( $(this) );
    });
})

export default {

    initMap: function(el) {
        new GoogleMap( el );
    },

    setMapLocation: function(el,location) {
        if(!el.data('google-map')) {
            el = el.find('[data-google-map]');
            if(!el.length) return;
        }
        if(!el.data('gm')) return;
        el.data('gm').setLocation( location );
    }
}
